export const restoreProductRedirect = (url) => {
    if (typeof url !== 'string') return url;
    return url.replace(
        /^https:\/\/xrhpsottqrqmm4fs5jthv6r6ci0kkiuk\.lambda-url\.ap-northeast-2\.on\.aws(?=[/?#]|$)/,
        'https://product.gentooai.com'
    );
};
